// Funcion que devuelve las sucursales según la ciudad
export function getSucursalesGroupedByCity(): {
  city: string;
  sucursales: string[];
}[] {
  return [
    {
      city: 'La Ceiba',
      sucursales: ['01'],
    },
    {
      city: 'Tegucigalpa',
      sucursales: ['05', '08', '11', '12', '13', '14', '81'],
    },
    {
      city: 'San Pedro Sula',
      sucursales: ['04', '06', '07', '80'],
    },
    {
      city: 'El Progreso',
      sucursales: ['09'],
    },
    {
      city: 'Choloma',
      sucursales: ['15'],
    },
  ];
}
